import loginManagament from "@/services/userManagement";
import {
    ACCESS_TOKEN, AVAILABLESTORES,
    REFRESH_TOKEN,
    RESOURCES, STORES,
    USER,
} from "@/utils/constants";
import employeeService from "@/services/employeeService";
import customStoreService from "@/services/customStore";

export default {
    namespaced: true,
    state: {
        user: null,
        token: null,
        refresh_token: null,
        resources: [],
        stores:[],
        availableStores:[]
    },
    mutations: {
        SET_TOKEN: (state, payload) => {
            localStorage.setItem(ACCESS_TOKEN, JSON.stringify(payload));
            state.token = payload;
        },
        SET_REFRESH_TOKEN: (state, payload) => {
            localStorage.setItem(REFRESH_TOKEN, JSON.stringify(payload));
            state.refresh_token = payload;
        },
        SET_RESOURCES: (state, payload) => {
            localStorage.setItem(RESOURCES, JSON.stringify(payload));
            state.resources = payload;
        },
        SET_USERID: (state, payload) => {
            localStorage.setItem(USER, JSON.stringify(payload));
            state.user = payload;
        },
        SET_STORES: (state, payload) => {
            localStorage.setItem(STORES, JSON.stringify(payload))
            state.stores = payload
        },
        SET_AVAILABLE_STORES: (state, payload) => {
            localStorage.setItem(AVAILABLESTORES, JSON.stringify(payload))
            state.availableStores = payload
            localStorage.setItem('selectedStore',  payload[0])
        },
        CLEAR_TOKEN: (state) => {
            localStorage.clear();
            state.token = null;
            state.refresh_token = null;
            state.user = null;
            state.resources = [];
            state.stores = [];
            state.availableStores = []
        },
    },
    actions: {
        async fetchUser({commit}, payload) {
            try {
                const {access_token, refresh_token, resources, stores} =
                    await loginManagament.login(payload);
                commit("SET_TOKEN", access_token);
                commit("SET_REFRESH_TOKEN", refresh_token);
                commit("SET_RESOURCES", resources);
                commit("SET_AVAILABLE_STORES", stores)
                const userIdData = await employeeService.getMeById();
                commit("SET_USERID", userIdData);
                const resStores = await customStoreService.getDataByModule(
                  "stores",
                  "",
                  1,
                  100
                )
                commit("SET_STORES", resStores.data)
                return {
                    message: "success",
                    status: "success",
                };
            } catch (e) {
                return {
                    message: e,
                    status: "failed",
                };
            }
        },
        refreshToken({commit}, payload) {
            commit("SET_TOKEN", payload?.access_token);
            commit("SET_REFRESH_TOKEN", payload?.refresh_token);
        },
    },
    getters: {
        getResources(state) {
            let resources = JSON.parse(localStorage.getItem(RESOURCES));
            state.resources = resources
            return state.resources
        },
        getUser(state) {
            let user = JSON.parse(localStorage.getItem(USER));
            state.user = user
            return state.user
        },
        getStores(state) {
            let stores = JSON.parse(localStorage.getItem(STORES));
            let availableStores = JSON.parse(localStorage.getItem(AVAILABLESTORES))
            state.stores = stores
            state.availableStores = availableStores
            return state.stores.filter((item)=>state.availableStores.includes(item?.uuid))
        }
    },
};
